import React from 'react'
import { createRoot } from 'react-dom/client'
import { Auth0Provider } from '@auth0/auth0-react'
import { AppController } from './AppController' 
import config from './config'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'



import 'styles/bulma-setup.scss'

const root = createRoot(document.getElementById('root'))

const queryClient = new QueryClient()


root.render(
    <Auth0Provider
        domain={config.auth0.domain}
        clientId={config.auth0.clientId}
        audience={config.auth0.audience}
        redirectUri={window.location.origin}
        useRefreshTokens={true}
        cacheLocation="localstorage"
        onRedirectCallback={(appState) => {
            window.history.replaceState(
                {},
                document.title,
                appState?.returnTo || window.location.pathname
            )
        }}
    >
            <QueryClientProvider client={queryClient}>
             <AppController />
             <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
    </Auth0Provider>
    
)